// extracted by mini-css-extract-plugin
module.exports = {"overlay":"modal-module--overlay--2bVQ7","modal":"modal-module--modal--1HyQ7","content":"modal-module--content--34pq_"};